import { UserRole } from '~/Models/DTO/Role.model';
import {
  AccessListItem,
  AccessRoles,
  FitogramVersion,
  AccessRoles as AR,
} from './accessList.types';

export const getUserRoleFromAccessRole = (accessRole: AccessRoles) => {
  switch (accessRole) {
    case AccessRoles.TRAINER:
      return UserRole.TRAINER;
    case AccessRoles.RESTRICTED:
      return UserRole.RESTRICTED;
    case AccessRoles.FULL_ACCESS:
      return UserRole.FULL_ACCESS;
    case AccessRoles.ORGANISATION_MANAGER:
      return UserRole.ORGANISATION_MANAGER;
    default:
      return UserRole.TRAINER;
  }
};

export const isOnCorrectAppVersion = ({
  fitogramVersions,
  isInMockMode,
  mockedAppView,
  isUsingThePartnerTool,
}: {
  fitogramVersions: FitogramVersion[];
  isInMockMode: boolean;
  mockedAppView: FitogramVersion;
  isUsingThePartnerTool: boolean;
}) => {
  if (fitogramVersions.length === 0) {
    return false;
  }
  if (isInMockMode) {
    return fitogramVersions.includes(mockedAppView);
  }
  if (isUsingThePartnerTool) {
    return fitogramVersions.includes(FitogramVersion.PartnerTool);
  }
  return fitogramVersions.includes(FitogramVersion.Neo);
};

export const hasFeaterKeyAccess = ({
  featureKeyAccess,
  isInMockMode,
  mockedAppView,
  mockedUserView,
  isUsingThePartnerTool,
  DANGEROUSLY_isPartnergramSupportAgent,
  DANGEROUSLY_isSuperAdmin,
}: {
  featureKeyAccess: boolean;
  isInMockMode: boolean;
  mockedAppView: FitogramVersion;
  mockedUserView: AccessRoles;
  isUsingThePartnerTool: boolean;
  DANGEROUSLY_isPartnergramSupportAgent: boolean;
  DANGEROUSLY_isSuperAdmin: boolean;
}) => {
  if (isInMockMode) {
    if (mockedAppView === FitogramVersion.PartnerTool) {
      return mockedUserView === AccessRoles.PARTNER_TOOL_ADMIN || featureKeyAccess;
    }
    return mockedUserView === AccessRoles.FITOGRAM_SUPER_ADMIN || featureKeyAccess;
  }
  if (isUsingThePartnerTool) {
    return DANGEROUSLY_isPartnergramSupportAgent || featureKeyAccess;
  }
  return DANGEROUSLY_isSuperAdmin || featureKeyAccess;
};

const isRoleIncludedInTheList = (role: UserRole | undefined, accessListItem: AccessListItem) =>
  (role === UserRole.TRAINER && accessListItem.accessToOneOf?.includes(AR.TRAINER)) ||
  (role === UserRole.RESTRICTED && accessListItem.accessToOneOf?.includes(AR.RESTRICTED)) ||
  (role === UserRole.FULL_ACCESS && accessListItem.accessToOneOf?.includes(AR.FULL_ACCESS)) ||
  (role === UserRole.ORGANISATION_MANAGER &&
    accessListItem.accessToOneOf?.includes(AR.ORGANISATION_MANAGER));

export const hasUserAccess = ({
  accessListItem,
  userRole,
  isUsingThePartnerTool,
  DANGEROUSLY_isPartnergramSupportAgent,
  DANGEROUSLY_isSuperAdmin,
  isInMockMode,
  mockedUserView,
  mockedAppView,
}: {
  accessListItem: AccessListItem;
  userRole?: UserRole;
  isUsingThePartnerTool: boolean;
  DANGEROUSLY_isPartnergramSupportAgent: boolean;
  DANGEROUSLY_isSuperAdmin: boolean;
  isInMockMode: boolean;
  mockedUserView: AccessRoles;
  mockedAppView: FitogramVersion;
}) => {
  if (accessListItem.accessToOneOf.length === 0) {
    return true;
  }
  if (accessListItem.accessToOneOf.includes(AR.NO_ACCESS)) {
    return false;
  }
  if (isInMockMode) {
    if (mockedAppView === FitogramVersion.PartnerTool) {
      if (mockedUserView === AccessRoles.FITOGRAM_SUPER_ADMIN) {
        return true;
      }
      if (mockedUserView === AccessRoles.PARTNER_TOOL_ADMIN) {
        return (
          accessListItem.accessToOneOf.includes(AR.PARTNER_TOOL_ADMIN) ||
          isRoleIncludedInTheList(UserRole.TRAINER, accessListItem) ||
          isRoleIncludedInTheList(UserRole.RESTRICTED, accessListItem) ||
          isRoleIncludedInTheList(UserRole.FULL_ACCESS, accessListItem)
        );
      }
      return isRoleIncludedInTheList(getUserRoleFromAccessRole(mockedUserView), accessListItem);
    }
    if (mockedUserView === AccessRoles.FITOGRAM_SUPER_ADMIN) {
      return true;
    }
    return isRoleIncludedInTheList(getUserRoleFromAccessRole(mockedUserView), accessListItem);
  }
  if (isUsingThePartnerTool) {
    if (DANGEROUSLY_isSuperAdmin) {
      return true;
    }
    if (DANGEROUSLY_isPartnergramSupportAgent) {
      return (
        accessListItem.accessToOneOf.includes(AR.PARTNER_TOOL_ADMIN) ||
        isRoleIncludedInTheList(UserRole.TRAINER, accessListItem) ||
        isRoleIncludedInTheList(UserRole.RESTRICTED, accessListItem) ||
        isRoleIncludedInTheList(UserRole.FULL_ACCESS, accessListItem)
      );
    }
    return isRoleIncludedInTheList(userRole, accessListItem);
  }
  if (DANGEROUSLY_isSuperAdmin) {
    return true;
  }
  return isRoleIncludedInTheList(userRole, accessListItem);
};
